
import { Badge } from "@/components/ui/badge";
import { Part } from "@/data/parts";

interface PartDetailsContentProps {
  part: Part;
}

const PartDetailsContent = ({ part }: PartDetailsContentProps) => {
  return (
    <div className="mb-6">
      <h1 className="text-3xl font-bold mb-4">{part.name}</h1>
      
      <div className="flex flex-wrap gap-2 mb-6">
        {part.filters.map(filter => (
          <Badge key={filter} variant="secondary">{filter}</Badge>
        ))}
      </div>
      
      <div>
        <h2 className="text-xl font-semibold mb-4">Description</h2>
        <p className="text-muted-foreground">{part.description}</p>
      </div>
    </div>
  );
};

export default PartDetailsContent;
